"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconExpressCustomerService = function IconExpressCustomerService(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m23.833 16.133 2.234.134-1.734 1.4.567 2.2-1.867-1.234-1.866 1.234.566-2.2-1.733-1.4 2.233-.134.8-2.133zM33.067 16.267l-2.234-.134-.8-2.133-.8 2.133-2.233.134 1.733 1.4-.566 2.2 1.866-1.234 1.867 1.234-.567-2.2zM37.833 16.133l2.234.134-1.734 1.4.567 2.2-1.867-1.234-1.866 1.234.566-2.2-1.733-1.4 2.233-.134.8-2.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M20.73 8h18.54A4.73 4.73 0 0 1 44 12.7v9.532A4.73 4.73 0 0 1 39.27 27h-1.421l-4.128 4.207L29.58 27H20.73a4.73 4.73 0 0 1-3.18-1.229l-.183-.174A4.72 4.72 0 0 1 16 22.23v-9.538A4.73 4.73 0 0 1 20.73 8m18.54 2H20.73A2.73 2.73 0 0 0 18 12.7v9.54A2.73 2.73 0 0 0 20.73 25h9.689l3.3 3.353L37.01 25h2.26A2.73 2.73 0 0 0 42 22.24v-9.532A2.73 2.73 0 0 0 39.27 10",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M14 23v-2H7.29l-.235.006a4.33 4.33 0 0 0-2.739 1.164A4.12 4.12 0 0 0 3 25.137v7.653l.013.242c.086 1.044.55 2.001 1.308 2.702l.165.16A4.3 4.3 0 0 0 7.263 37l1.261-.001 3.686 3.574 2.336-2.265 1.357-1.309L23.71 37l.245-.013a4.34 4.34 0 0 0 2.76-1.288l.154-.15A4.1 4.1 0 0 0 28 32.762L28 29h-2v3.75l-.011.189c-.053.5-.29.976-.668 1.327a2.37 2.37 0 0 1-1.638.734h-8.586l-1.94 1.87-.948.917L9.335 35H7.29l-.192-.014a2.33 2.33 0 0 1-1.383-.685A2.16 2.16 0 0 1 5 32.764V25.15l.011-.189c.053-.5.29-.976.668-1.327A2.33 2.33 0 0 1 7.286 23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M17 28.97v-1H9v1zM23 30.97v1H9v-1z"
  })));
};

export { IconExpressCustomerService, IconExpressCustomerService as default };
